import * as React from "react";

const IconHeaderNavDropdownUp: React.FC = () => {
    return <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 9 6"  strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" focusable="false" width="24" height="24" fill="currentColor"><path fill="#298CF0" d="M4.5.25a.747.747 0 00-.53.22L.22 4.22a.75.75 0 101.06 1.06L4.5 2.06l3.22 3.22a.75.75 0 101.06-1.06L5.03.47A.748.748 0 004.5.25z"/></svg>;
};

export default React.memo(IconHeaderNavDropdownUp);
